var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyRodeoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "create-manually 24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4712 3.82639C8.87288 4.09697 7.79064 4.78616 7.17362 5.95308C6.06813 8.04383 6.5384 9.57404 6.15181 11.119C5.76521 12.6639 4.57994 13.1817 3.72746 14.3909C3.06205 15.3348 2.95694 17.6305 4.14939 18.7768C5.32911 19.9019 6.417 20.945 8.53508 20.6272C10.6319 20.3221 11.6891 18.9089 13.8921 18.4679C16.0951 18.027 17.9197 18.4307 19.0921 17.3844C20.3214 16.2872 21.6002 13.2526 20.5018 11.0623C19.6182 9.30049 17.2431 9.19349 16.1951 7.54214C15.1471 5.89079 14.827 4.95676 13.9673 4.47317C12.8175 3.82644 11.7773 3.60528 10.4712 3.82639Z",
    stroke: "#363432",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyRodeoIcon);
export default __webpack_public_path__ + "static/media/my-rodeo-icon.ad892979235a743ec023fd379f109d11.svg";
export { ForwardRef as ReactComponent };